import { render, staticRenderFns } from "./SkillsgapLayout.vue?vue&type=template&id=0878eece&"
import script from "./SkillsgapLayout.vue?vue&type=script&lang=js&"
export * from "./SkillsgapLayout.vue?vue&type=script&lang=js&"
import style0 from "./SkillsgapLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports